import {
  Box,
  Typography,
  List,
  Grid,
  Paper,
  Chip,
  Avatar,
} from "@mui/material";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../application/states/hooks";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import { setUnselectEconimicActivityListState } from "../../../../../../../application/states/economic-activity-list";
import { IEconomicActivityList } from "../../../../../../../application/models";
import { useEconomicActivityListService } from "../../../../../../../use-cases/economic-activity-list";
import { useState } from "react";
import { theme } from "../../../../../../styles";
// import { removeListaCBOFilterState } from "../../../../../../../../application/states/geo-veles";

export const EconomicActivityListFilterPreview = () => {
  const projectState = useAppSelector((state) => state.project);
  const { company } = useAppSelector((state) => state.company);

  const { setUnselectList } = useEconomicActivityListService();
  let purge: boolean;
  const handleRemove = (list: IEconomicActivityList) => {
    setUnselectList(list.id, purge);
  };
  return (
    <List>
      {(projectState?.selectedFilter?.economicActivityList?.length ?? 0) > 0 ? (
        <>
          <Paper elevation={2} sx={{ my: 2, p: 2 }}>
            <Box mb={1}>
              <Typography variant="h6" color="primary" fontWeight={"bold"}>
                Incluir estas listas
              </Typography>
            </Box>
            {(projectState?.selectedFilter?.economicActivityList?.length ?? 0) >
            0 ? (
              <Box my={3}>
                <Typography color="primary" fontWeight={"bold"}>
                  Filtros de cnae selecionados:
                </Typography>
              </Box>
            ) : null}
            <Grid container spacing={3}>
              {projectState.selectedFilter?.economicActivityList?.map(
                (list, index) => {
                  return (
                    <Grid item key={list.id} marginBottom={2}>
                      <Chip
                        sx={{
                          height: "auto",
                          "& .MuiChip-label": {
                            transition: "0.1s all",
                            display: "block",
                            whiteSpace: "normal",
                            padding: "10px 15px",
                            fontWeight: "bold",
                            color:
                              company?.resale === true || company?.resaleId
                                ? theme.palette.primary.contrastText
                                : "#FFF",
                          },
                        }}
                        color="primary"
                        onDelete={() => {
                          purge = false;
                          handleRemove(list);
                        }}
                        avatar={
                          <Avatar
                            key={index}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <FormatListBulletedIcon
                              sx={{
                                "&": {
                                  transition: "0.1s all",
                                  color:
                                    company?.resale === true ||
                                    company?.resaleId
                                      ? theme.palette.primary.contrastText
                                      : "#FFF",
                                },
                                "&:hover": {
                                  color:
                                    company?.resale === true ||
                                    company?.resaleId
                                      ? theme.palette.primary.contrastText
                                      : "#FFF",
                                  cursor: "default",
                                },
                                borderRadius: "8px",
                                backgroundColor:
                                  company?.resale === true || company?.resaleId
                                    ? theme.palette.primary.main
                                    : theme.palette.primary.main, // Roxo para não-resale
                                color:
                                  company?.resale === true || company?.resaleId
                                    ? theme.palette.primary.contrastText
                                    : "#FFF",
                              }}
                            />
                          </Avatar>
                        }
                        label={`${list.name.toUpperCase()} (${Array.isArray(list.economicActivityList) ? list.economicActivityList.length : 0} CNAEs)`}
                      />
                    </Grid>
                  );
                },
              )}
            </Grid>
          </Paper>
        </>
      ) : null}

      {(projectState?.selectedFilter?.purgeEconomicActivityLists?.length ?? 0) >
      0 ? (
        <>
          <Paper elevation={2} sx={{ my: 2, p: 2 }}>
            <Box mb={1}>
              <Typography variant="h6" color="primary" fontWeight={"bold"}>
                Não incluir estas listas
              </Typography>
            </Box>
            {(projectState?.selectedFilter?.purgeEconomicActivityLists
              ?.length ?? 0) > 0 ? (
              <Box my={3}>
                <Typography color="primary" fontWeight={"bold"}>
                  Filtros de cnaes para deduplicação
                </Typography>
              </Box>
            ) : null}
            <Grid container spacing={3}>
              {projectState.selectedFilter?.purgeEconomicActivityLists?.map(
                (list, index) => {
                  return (
                    <Grid item key={list.id} marginBottom={2}>
                      <Chip
                        sx={{
                          height: "auto",
                          "& .MuiChip-label": {
                            transition: "0.1s all",
                            display: "block",
                            whiteSpace: "normal",
                            padding: "10px 15px",
                            fontWeight: "bold",
                            color:
                              company?.resale === true || company?.resaleId
                                ? theme.palette.secondary.contrastText
                                : "#FFF",
                          },
                        }}
                        color="secondary"
                        onDelete={() => {
                          purge = true;
                          handleRemove(list);
                        }}
                        avatar={
                          <Avatar
                            key={index}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <FormatListBulletedIcon
                              sx={{
                                "&": {
                                  transition: "0.1s all",
                                  color:
                                    company?.resale === true ||
                                    company?.resaleId
                                      ? theme.palette.secondary.contrastText
                                      : "#FFF",
                                },
                                "&:hover": {
                                  color:
                                    company?.resale === true ||
                                    company?.resaleId
                                      ? theme.palette.secondary.contrastText
                                      : "#FFF",
                                  cursor: "default",
                                },
                                borderRadius: "8px",
                                backgroundColor:
                                  company?.resale === true || company?.resaleId
                                    ? theme.palette.secondary.main
                                    : theme.palette.secondary.main, // Roxo para não-resale
                                color:
                                  company?.resale === true || company?.resaleId
                                    ? theme.palette.secondary.contrastText
                                    : "#FFF",
                              }}
                            />
                          </Avatar>
                        }
                        label={`${list.name.toUpperCase()} (${Array.isArray(list.economicActivityList) ? list.economicActivityList.length : 0} CNAEs)`}
                      />
                    </Grid>
                  );
                },
              )}
            </Grid>
          </Paper>
        </>
      ) : null}
    </List>
  );
};
